import CheckAuthApp from "@features/auth/components/CheckAuthApp";
import Login from "@features/auth/components/Login";
import Logout from "@features/auth/components/Logout";
import OttExchange from "@features/auth/components/OttExchange";
import PasswordReset from "@features/auth/components/PasswordReset";
import Register from "@features/auth/components/Register";
import TwoFactor from "@features/auth/components/TwoFactor";
import JoinForm from "@features/auth/components/JoinForm/JoinForm";
import { QESConnect } from "@features/auth/components/QESConnect/QESConnect";
import VerifyAlternativeEmail from "@features/user/pages/security/components/VerifyAlternativeEmail";
import { ROUTES } from "@app/config/constants";
import { Route } from "react-router-dom";

export default function getAuthRoutes() {
  return (
    <>
      <Route path={ROUTES.REGISTER} element={<Register />} />
      <Route path={ROUTES.REGISTER_CHECK_EMAIL} element={<CheckAuthApp />} />
      <Route path={ROUTES.LOGIN} element={<Login />} />
      <Route path={ROUTES.LOGOUT} element={<Logout />} />
      <Route path={ROUTES.OTT} element={<OttExchange />} />
      <Route path={ROUTES.PASSWORD_RESET} element={<PasswordReset />} />
      <Route path={ROUTES.TWO_FACTOR} element={<TwoFactor />} />
      <Route path={ROUTES.JOIN} element={<JoinForm />} />
      <Route path={ROUTES.QES_CONNECT} element={<QESConnect />} />
      <Route
        path={ROUTES.ALTERNATIVE_EMAIL_VERIFY}
        element={<VerifyAlternativeEmail />}
      />
    </>
  );
}
